export default __webpack_public_path__ + "static/media/no-table-rows.356df282.svg";